import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Phone, MessageSquare } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { SITE } from "@/lib/site";
import Home from "@/pages/Home";
import Inventory from "@/pages/Inventory";
import VehicleDetail from "@/pages/VehicleDetail";
import Service from "@/pages/Service";
import Financing from "@/pages/Financing";
import Performance from "@/pages/Performance";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const FloatingActions = () => (
  <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3" data-testid="floating-actions">
    <a
      href={SITE.smsHref}
      data-testid="floating-text-button"
      aria-label="Text us"
      className="flex h-13 w-13 items-center justify-center border border-white/15 bg-black/70 p-3.5 text-zinc-300 backdrop-blur-xl transition-colors duration-300 hover:border-trx-blue hover:text-white"
    >
      <MessageSquare className="h-5 w-5" />
    </a>
    <a
      href={SITE.phoneHref}
      data-testid="floating-call-button"
      aria-label="Call us"
      className="flex items-center justify-center bg-trx-blue p-3.5 text-white transition-colors duration-300 hover:bg-white hover:text-black"
    >
      <Phone className="h-5 w-5" />
    </a>
  </div>
);

const Shell = () => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-trx-black text-foreground">
      <ScrollToTop />
      {!isAdmin && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/inventory/:id" element={<VehicleDetail />} />
          <Route path="/service" element={<Service />} />
          <Route path="/financing" element={<Financing />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingActions />}
      <Toaster theme="dark" position="top-center" toastOptions={{ style: { background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.12)", borderRadius: "2px" } }} />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
